import { FC } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as CloseIcon } from 'src/assets/svg/modal-close.svg'
import styles from './deleteLocationModal.module.scss'

interface Props {
  isOpen: boolean
  isPending?: boolean
  locationName: string
  onClose: () => void
  onConfirm: () => void
}

export const DeleteLocationModal: FC<Props> = ({
  isOpen,
  isPending = false,
  locationName,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return createPortal(
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>Are you sure?</h2>
          <button className={styles.closeBtn} onClick={onClose} type="button">
            <CloseIcon />
          </button>
        </div>

        <p className={styles.body}>
          Are you sure you want to delete{' '}
          <strong className={styles.locationName}>{locationName}</strong>? This
          will remove it from monitoring.
        </p>

        <div className={styles.footer}>
          <button className={styles.discardBtn} onClick={onClose} type="button">
            Discard
          </button>
          <button
            className={styles.removeBtn}
            disabled={isPending}
            onClick={onConfirm}
            type="button"
          >
            {isPending ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
